import { useEffect, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import cn from 'classnames'

export type InlineEditableSimpleDescriptionProps = {
  value: string
  onChange: (value: string) => void
  placeholder: string
  ariaLabel: string
}

export const InlineEditableSimpleDescription = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
}: InlineEditableSimpleDescriptionProps) => {
  const TEXT_AREA_STYLE: object = {
    fieldSizing: 'content',
  }
  //Form is observabale but not the internal props so react is not aware of the
  // changes and I need to use useState + useEffect to update the local value
  const [localValue, setLocalValue] = useState(value)

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const handleChange = (newValue: string) => {
    setLocalValue(newValue)
    onChange(newValue)
  }

  return (
    <Box width="full" position="relative">
      <textarea
        value={localValue}
        aria-label={ariaLabel}
        placeholder={placeholder}
        onChange={(e) => handleChange(e.target.value)}
        className={cn(
          'w-full resize-none bg-transparent px-2 py-1',
          'text-base text-f1-foreground-secondary',
          'placeholder:text-f1-foreground-tertiary',
          'border-none outline-none',
          'focus:outline-none focus:ring-0'
        )}
        style={TEXT_AREA_STYLE}
        rows={1}
      />
    </Box>
  )
}
